import { fetchPrivateBlob } from 'services/PrivateFileService'

export default {
    methods: {
        fetchPrivateBlob,
        downloadFile(url, label) {
            this.fetchPrivateBlob(url)
                .then((blob) => {
                    const objectUrl = window.URL.createObjectURL(blob)
                    const link = document.createElement('a')
                    link.href = objectUrl
                    link.setAttribute('download', label)
                    document.body.appendChild(link)
                    link.click()
                    link.remove()
                    window.URL.revokeObjectURL(objectUrl)
                })
                .catch(() => {})
        },
    },
}
